import React from "react";

/**
 * Global noise/grain texture overlay
 * Adds subtle visual texture to the entire app
 * Respects prefers-reduced-motion
 */
export const NoiseOverlay = () => {
  return (
    <div 
      className="noise-overlay" 
      aria-hidden="true"
      data-testid="noise-overlay"
    />
  );
};

export default NoiseOverlay;
